import React from 'react';
import { motion } from 'framer-motion';
export function WhyUs() {
  const reasons = [{
    title: 'Solo Meta Ads, a fondo',
    desc: 'No nos dispersamos. Vivimos dentro del Administrador de Anuncios y conocemos cada palanca que mueve resultados.'
  }, {
    title: 'Te hablamos de dinero, no de likes',
    desc: 'Nuestra métrica norte es el retorno. Todo lo demás es ruido que ignoramos por ti.'
  }, {
    title: 'Comunicación directa y constante',
    desc: 'Sin intermediarios ni respuestas en 5 días. Trabajas con el equipo que toca tu cuenta de verdad.'
  }, {
    title: 'Sin permanencias absurdas',
    desc: 'Nos quedamos por resultados, no por contrato. Si no aportamos valor, eres libre de irte.'
  }];
  return <section className="relative py-[110px]" id="porque" data-id="element-200">
      <div className="max-w-wrap mx-auto px-7 grid grid-cols-1 md:grid-cols-[1.1fr_0.9fr] gap-10 md:gap-[60px] items-center" data-id="element-201">
        <motion.div initial={{
        opacity: 0,
        y: 34
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-10%'
      }} transition={{
        duration: 0.8,
        ease: [0.2, 0.7, 0.2, 1]
      }} data-id="element-202">
          <div className="font-mono text-[0.74rem] tracking-[0.16em] text-acid uppercase flex items-center gap-[10px] mb-5 before:content-[''] before:w-[28px] before:h-[1px] before:bg-acid" data-id="element-203">
            Por qué nosotros
          </div>
          <h2 className="text-[clamp(2rem,4.6vw,3.5rem)] font-bold tracking-[-0.03em] leading-[1.02] max-w-[14ch]" data-id="element-204">
            Especialistas, no{' '}
            <span className="font-serif italic font-normal" data-id="element-205">generalistas.</span>
          </h2>

          <div className="mt-[30px]" data-id="element-206">
            {reasons.map((reason, i) => <div key={i} className="flex gap-[18px] py-[22px] border-t border-line" data-id="element-207">
                <div className="shrink-0 w-[30px] h-[30px] rounded-full bg-acid text-[#0a0c0b] grid place-items-center font-extrabold text-[0.9rem]" data-id="element-208">
                  ✓
                </div>
                <div data-id="element-209">
                  <h4 className="text-[1.12rem] font-bold mb-1" data-id="element-210">
                    {reason.title}
                  </h4>
                  <p className="text-ink-dim text-[0.94rem]" data-id="element-211">{reason.desc}</p>
                </div>
              </div>)}
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 34
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-10%'
      }} transition={{
        duration: 0.8,
        ease: [0.2, 0.7, 0.2, 1],
        delay: 0.14
      }} className="aspect-[1/1.05] rounded-[24px] border border-line bg-[linear-gradient(155deg,#11150f,#0a0c0b)] relative overflow-hidden p-8 flex flex-col justify-between" data-id="element-212">
          <div className="absolute bottom-[-30%] right-[-20%] w-[380px] h-[380px] rounded-full bg-[radial-gradient(circle,rgba(196,255,61,0.18),transparent_65%)] blur-[10px]" data-id="element-213"></div>

          <div className="relative z-10 font-mono text-[0.72rem] text-ink-faint tracking-[0.1em]" data-id="element-214">
            // RENDIMIENTO EN TIEMPO REAL
          </div>

          <div className="relative z-10" data-id="element-215">
            <div className="text-[clamp(3.4rem,9vw,5.4rem)] font-extrabold tracking-[-0.04em] leading-[0.9]" data-id="element-216">
              <span className="text-acid" data-id="element-217">3,8</span>x
            </div>
            <div className="text-ink-dim mt-[10px]" data-id="element-218">
              ROAS medio de las cuentas que gestionamos activamente.
            </div>
          </div>

          <div className="flex gap-[6px] items-end h-[90px] relative z-10" data-id="element-219">
            {Array.from({
            length: 22
          }).map((_, i) => <i key={i} className="flex-1 bg-[rgba(196,255,61,0.25)] rounded-[3px] animate-grow origin-bottom" style={{
            animationDelay: `${i * 0.12}s`,
            animationDuration: `${2 + Math.random() * 1.4}s`
          }} data-id="element-220"></i>)}
          </div>
        </motion.div>
      </div>
    </section>;
}